import { Component } from '@angular/core';

@Component({
  selector: 'app-my-resources-page',
  templateUrl: './my-resources-page.component.html',
  styleUrls: ['./my-resources-page.component.scss'],
})
export class MyResourcesPageComponent {}
